import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import BSL_Button from "./BSL_Button";
import BSL_TextInput from "./BSL_TextInput";
import Draggable from "react-draggable";

function PaperComponent(props) {
    let drag_key = props?.["aria-describedby"] ? props?.["aria-describedby"].split(" ")[0] : "";

    return (
        <Draggable handle={"#draggable-dialog-title" + drag_key} cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper id={"draggable-dialog-title" + drag_key} {...props} />
        </Draggable>
    );
}

const useStyles = makeStyles((theme) => ({
    content: {
        font: "16px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        whiteSpace: "pre-wrap",
    },
}));

export function BSL_DialogData(props) {
    const { dialogData, dispatch } = props;
    if (!dialogData) return null;

    return (
        <BSL_Dialog
            {...props}
            style={dialogData.style}
            title={dialogData.title}
            open={dialogData}
            onClose={() => dispatch(dialogData.onClose)}
            button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
            button1Click={() => {
                dispatch(dialogData.onClose);
                if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
            }}
            button2Text={dialogData?.secondaryActionText}
            button2Click={() => {
                dispatch(dialogData.onClose);
                if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
            }}
        >
            {dialogData.message}
        </BSL_Dialog>
    );
}

export default function BSL_Dialog(props) {
    const classes = useStyles();
    const [inputText, setInputText] = React.useState(props?.inputValue ? props?.inputValue : "");
    const handleClose = () => {
        if (props.onClose) props.onClose();
    };

    let drag_key = props.id ? props.id.split(" ")[0] + " " : "";

    return (
        <div>
            <Dialog
                open={props?.open ? true : false}
                onClose={handleClose}
                aria-labelledby={"alert-dialog-title draggable-dialog-title"}
                aria-describedby={drag_key + "alert-dialog-description"}
                disableScrollLock={true}
                style={props.style}
                maxWidth={props.maxWidth}
                fullWidth={props.fullWidth}
                PaperComponent={PaperComponent}
                onClick={(e) => e.stopPropagation()}
            >
                {props.title && (
                    <DialogTitle id="alert-dialog-title" style={{ cursor: "move" }}>
                        {props.title}
                    </DialogTitle>
                )}
                {(props.children || props.htmlContent || props.text || props.allowMultilineInput) && (
                    <DialogContent
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            ...(props.contentStyle ? props.contentStyle : {}),
                            whiteSpace: "pre-wrap",
                            minWidth: "350px",
                        }}
                    >
                        {props.htmlContent && <div dangerouslySetInnerHTML={{ __html: props.htmlContent }}></div>}
                        {props.text && (
                            <DialogContentText className={classes.content} id="alert-dialog-description">
                                {props.text}
                            </DialogContentText>
                        )}
                        {props.allowMultilineInput && (
                            <BSL_TextInput
                                multiline
                                tight
                                autoFocus
                                placeholder={props?.inputPlaceholder}
                                rows={4}
                                style={{
                                    flex: 1,
                                }}
                                value={inputText}
                                onBlur={(value) => {
                                    setInputText(value);
                                    if (props?.inputBlur) props.inputBlur(value);
                                }}
                                onChange={(value) => {
                                    setInputText(value);
                                    if (props?.inputOnChange) props.inputOnChange(value);
                                }}
                            />
                        )}
                        {props.children}
                    </DialogContent>
                )}
                <DialogActions>
                    {props.button4Text && (
                        <BSL_Button
                            onClick={() => props.button4Click(inputText)}
                            disabled={props.button4Disabled}
                            secondary
                        >
                            {props.button4Text}
                        </BSL_Button>
                    )}
                    {props.button3Text && (
                        <BSL_Button
                            onClick={() => props.button3Click(inputText)}
                            disabled={props.button3Disabled}
                            secondary
                        >
                            {props.button3Text}
                        </BSL_Button>
                    )}
                    {props.button2Text && (
                        <BSL_Button
                            onClick={(e) => props.button2Click(e, inputText)}
                            disabled={props.button2Disabled}
                            secondary
                        >
                            {props.button2Text}
                        </BSL_Button>
                    )}
                    {props.button1Text && (
                        <BSL_Button
                            id={props?.button1Id}
                            onClick={(e) => props.button1Click(e, inputText)}
                            disabled={props.button1Disabled}
                            color="primary"
                        >
                            {props.button1Text}
                        </BSL_Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}
